<template>
  <div id="blog" class="has-background-grey-lighter section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h3 class="is-size-3">Blog</h3>
        </div>
      </div>
      <div class="columns is-multiline" v-if="blogs != []">
        <div
          class="column is-one-third"
          v-for="(post, index) in blogs"
          :key="index"
        >
          <post-card v-bind:post="post" :odd="index % 2 === 0" />
        </div>
      </div>
      <div class="columns is-multiline" v-if="blogs == []">
        <div class="column is-12">
          {{ $t("noRecords") }}
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
import PostCard from "@/components/PostCard.vue";
export default {
  name: "blog",
  data() {
    return {
      options: ["Eventos", "Novedades", "Noticias", "New release", "Todos"],
      blogs: [],
    };
  },
  components: { PostCard },
  mounted() {
    this.loadPost();
  },
  methods: {
    async loadPost() {
      this.blogs = [];
      await import("@/assets/post.json")
        .then((res) => {
          // console.log(res.data)
          this.blogs = res.data;
        })
        .then(() => {
          this.blogs = this.blogs.filter((e) => e.status);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<i18n>
{
  "es": {
    "noRecords":"No se encontraron noticias"
  },
  "en": {
    "noRecords":"No news found"
  },
  "pt": {
    "noRecords":"Nenhuma notícia encontrada"
  }
}    
</i18n>
